import clsx from 'clsx';
import React from 'react';

const Select = ({ children, className, onBlur, ...props }) => (
  <select
    onBlur={onBlur}
    className={clsx(
      `appearance-none block w-full text-gray-800 rounded text-left border-none shadow-input focus:shadow-input-focus`,
      className,
    )}
    {...props}
  >
    {children}
  </select>
);

export default Select;
